import React from "react";
import HeadCont from "../../components/common/HeadCont";

const Source = () => {
  // Function to convert URLs in text to clickable links
  const renderTextWithLinks = (text) => {
    if (!text) return null;

    const lines = text.split('\n');
    return lines.map((line, lineIndex) => {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = line.split(urlRegex);

      return (
        <React.Fragment key={lineIndex}>
          {parts.map((part, index) => {
            if (part.match(urlRegex)) {
              return (
                <a
                  key={index}
                  href={part}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline hover:text-blue-800 break-all"
                >
                  {part}
                </a>
              );
            }
            return <span key={index}>{part}</span>;
          })}
          {lineIndex < lines.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  const datas = [
    {
      id: 1,
      title: "1. Healiary References",
      contents: `1. Muscaritoli M, Arends J, Bachmann P, et al. ESPEN practical guideline: Clinical Nutrition in cancer. Clin Nutr. 2021;40(5):2898-2913. https://pubmed.ncbi.nlm.nih.gov/33946039/
2. Thompson KL, Elliott L, Fuchs-Tarlovsky V, et al. Oncology Evidence-Based Nutrition Practice Guideline for Adults. J Acad Nutr Diet. 2017;117(2):297-310.e47. https://pubmed.ncbi.nlm.nih.gov/27436529/
3. Lis CG, Gupta D, Lammersfeld CA, Markman M, Vashi PG. Role of nutritional status in predicting quality of life outcomes in cancer. Nutrition Journal. 2012;11:1–18. https://pubmed.ncbi.nlm.nih.gov/22531478/
4. Playdon MC, Bracken MB, Sanft TB, et al. Weight gain after breast cancer diagnosis and all-cause mortality. J Natl Cancer Inst. 2015;107(12). https://pubmed.ncbi.nlm.nih.gov/26424778/
5. Pang Y, Wei Y, Kartsonaki C. Associations of adiposity and weight change with recurrence and survival in breast cancer patients. Breast Cancer. 2020;29(4):575–588. https://pubmed.ncbi.nlm.nih.gov/35579841/
6. Zhao XH, Yang T, Ma XD, et al. Heterogeneity of nutrition care procedures in nutrition guidelines for cancer patients. Clin Nutr. 2020;39(6):1692–1704. https://pubmed.ncbi.nlm.nih.gov/31542246/
7. Pirat A, Tucker AM, Taylor KA, et al. Comparison of measured vs predicted energy requirements in critically ill cancer patients. Respir Care. 2009;54(4):487–494. https://pubmed.ncbi.nlm.nih.gov/19327184/
8. Khalid U, Spiro A, Baldwin C, et al. Symptoms and weight loss in patients with GI and lung cancer at presentation. Support Care Cancer. 2007;15:39–46. https://pubmed.ncbi.nlm.nih.gov/16786329/
9. Sánchez-Lara K, Ugalde-Morales E, Motola-Kuba D, Green D. GI symptoms and weight loss in cancer patients receiving chemotherapy. Br J Nutr. 2013;109(5):894–897. https://pubmed.ncbi.nlm.nih.gov/22691288/
10. Kubrak C, Olson K, Jha N, et al. Nutrition impact symptoms and dietary intake in head and neck cancer. Head & Neck. 2010;32(3):290–300. https://onlinelibrary.wiley.com/doi/abs/10.1002/hed.21174
11. Bergoz R, de Peyer R. Intestinal lactase and milk consumption before and after gastrectomy. Schweiz Med Wochenschr. 1979;109(16):605–606. https://www.jstage.jst.go.jp/article/kurumemedj1954/25/4/25_4_295/_pdf
12. Korean Dietetic Association. Manual of Medical Nutrition Therapy. 4th ed. 2022. https://synapse.koreamed.org/articles/1516085676
13. Rodgers L, Phillips CA. Dumping syndrome: Causes, management, and patient education. American Nurse Today. 2018;13(1):6–10. https://americannurnetoday.mydigitalpublication.com/articles/dumping-syndrome-causes-management-and-patient-education
14. Memorial Sloan Kettering Cancer Center. Eating After Your Gastrectomy. 2022. https://www.mskcc.org/pdf/cancer-care/patient-education/eating-after-your-gastrectomy
15. Center for Cancer Research. Diet and Nutrition After Gastrectomy: Your Plan. https://ccr.cancer.gov/surgical-oncology-program/clinical-team/diet-and-nutrition-after-gastrectomy-your-plan
16. Rogers C. Postgastrectomy nutrition. Nutr Clin Pract. 2011;26(2):126–136. https://pubmed.ncbi.nlm.nih.gov/21447764/
17. Akbulut G. Nutrition in stoma patients: a practical view of dietary therapy. Int J Hematol Oncol. 2011;32(4):061–066. https://www.semanticscholar.org/paper/Nutrition-in-Stoma-Patients/3dbf250fe3e91c3ffe178be14edbc713d4779d93
18. Burgess-Stocks J. Eating with an Ostomy. UOAA. 2022. https://www.ostomy.org/wp-content/uploads/2022/02/Eating_with_an_Ostomy_2022-02.pdf
19. Swan WI, Vivanti A, Hakel-Smith NA, et al. Nutrition Care Process and Model Update. J Acad Nutr Diet. 2017;117(12):2003–2014. https://www.jandonline.org/article/S2212-2672(17)31117-6/abstract`,
    },
    {
      id: 2,
      title: "2. Symptom Questionnaire",
      contents: `The PRO-CTCAE™ items and information herein were developed by the Division of Cancer Control and Population Sciences in the NATIONAL CANCER INSTITUTE at the NATIONAL INSTITUTES OF HEALTH, in Bethesda, Maryland, U.S.A.
Use of the PRO- CTCAE™ is subject to NCI's Terms of Use.`,
    },
    {
      id: 3,
      title: "3. Food & Nutrition Database",
      contents: "Korea Food & Drug Administration, Food Nutrition Composition Database, 2021.11.08. https://various.foodsafetykorea.go.kr/nutrient/",
    },
    {
      id: 4,
      title: "4. Recipe Database",
      contents: `Korea Food & Drug Administration, Recipe Database for Prepared Foods, 2020.05.25.
Korea Agricultural & Food Education & Information Service, Basic Recipe Information, 2017.01.09.
Korea Agricultural & Food Education & Information Service, Recipe Process Information, 2017.01.09.`,
    },
    {
      id: 5,
      title: "5. Patent",
      contents:
        "Meal Plan Providing System and Method for Cancer Patients - Patent No. 10-2474393",
      imgUrl: "/images/mobile/image/certificate.svg",
    },
  ];

  return (
    <>
      <HeadCont title={"Reference Sources"} />
      <section className="safe-area-mt-header border-t p-4">
        <ul className="whitespace-pre-line break-words">
          {datas.map((data) => (
            <li key={data.id} className="mb-4">
              <h2 className="text-caption2_700 text-gray_160 mb-2 select-text">
                {data.title}
              </h2>
              <div className="text-caption2_400 text-gray_120 select-text">
                {renderTextWithLinks(data.contents)}
              </div>
              {data?.imgUrl && (
                <img src={data.imgUrl} alt="Patent Certificate" className="mx-auto mt-2" />
              )}
            </li>
          ))}
        </ul>
      </section>
    </>
  );
};

export default Source;
